
<div class="sliderChart">
  <div v-for="rating in ratingLabels" :key="rating" class="sliderChart__item">
    <div class="sliderChart__label">{{ rating.toFixed(1) }}</div>
    <div class="sliderChart__container">
      <div class="sliderChart__slider" :style="{ '--width': calculatedWidth(rating) }">
        <div v-if="ratingCounts[rating] > 0" class="sliderChart__thumb" :style="{ left: calculatedWidth(rating) }"></div>
      </div>
    </div>
  </div>
</div>
